import createLucideIcon from '../createLucideIcon';

const Equal = createLucideIcon('Equal', [
  ['line', { x1: '5', x2: '19', y1: '9', y2: '9', key: '1nwqeh' }],
  ['line', { x1: '5', x2: '19', y1: '15', y2: '15', key: 'g8yjpy' }],
]);

export default Equal;
